import { connect } from 'react-redux'
import at from 'lodash/at'
import filter from 'lodash/filter'

import WorkOrders from '../../components/work-orders/work-orders'
import { loadWorkOrders } from '../../actions/work-orders'
import { loadAllLocations } from '../../actions/locations'

const mapStateToProps = (state) => {
  const workOrders = at(state.workOrders, state.pagination.workOrders.ids || [])
  const locations = state.allLocations;

  return {
    backlogWorkOrders: filter(workOrders, { backlog: true }),
    regularWorkOrders: filter(workOrders, { backlog: false }),
    locations: filter(locations, (location) => {
      return location.needsWorkIssueCount > 0;
    }),
    hasNextPage: !!state.pagination.workOrders.nextPageUrl
  }
}

const mapDispatchToProps = (dispatch) => {
  dispatch(loadWorkOrders())
  dispatch(loadAllLocations())

  return {
    onLoadNextPage () {
      dispatch(loadWorkOrders(true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrders)



// WEBPACK FOOTER //
// ./src/containers/work-orders/work-orders-container.js